export function AchievementsSection() {
    return (
        <section id="achievements-section">
            <div className="section-title">Achievements</div>
            <div className="container section-body">
                <h3>Full Decentralised and Currency Security</h3>
                <div className="stats">
                    <div className="item">
                        <div className="stat">1M+</div>
                        <div className="label">Users</div>
                    </div>

                    <div className="item">
                        <div className="stat">200K+</div>
                        <div className="label">Assets</div>
                    </div>

                    <div className="item">
                        <div className="stat">20K+</div>
                        <div className="label">Contributors</div>
                    </div>
                </div>

                <div className="world-map" />
            </div>
        </section>
    )
}